export const Types = {
    GET_BREAKDOWN_REASON_GROUP_LIST: "GET_BREAKDOWN_REASON_GROUP_LIST",
    SET_BREAKDOWN_REASON_GROUP_LIST: "SET_BREAKDOWN_REASON_GROUP_LIST",
    ADD_BREAKDOWN_REASON_GROUP: "ADD_BREAKDOWN_REASON_GROUP",
    UPDATE_BREAKDOWN_REASON_GROUP: "UPDATE_BREAKDOWN_REASON_GROUP",
    DELETE_BREAKDOWN_REASON_GROUP: "DELETE_BREAKDOWN_REASON_GROUP",
    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
};

export const getBreakdownReasonGroupList = (payload) => ({
    type: Types.GET_BREAKDOWN_REASON_GROUP_LIST,
});

export const setBreakdownReasonGroupList = (payload) => ({
    type: Types.SET_BREAKDOWN_REASON_GROUP_LIST,
    payload: payload,
});

export const addBreakdownReasonGroup = (payload) => {
    return {
        type: Types.ADD_BREAKDOWN_REASON_GROUP,
        payload: payload,
    };
};

export const updateBreakdownReasonGroup = (payload) => {
    return {
        type: Types.UPDATE_BREAKDOWN_REASON_GROUP,
        payload: payload,
    };
};

export const deleteBreakdownReasonGroup = (payload) => {
    return {
        type: Types.DELETE_BREAKDOWN_REASON_GROUP,
        payload: payload,
    };
};

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});
